

































































import _ from 'lodash'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import {
  ApiErrorHandle,
  ApiGeneralObjectArrayPayload,
  ApiGeneralSinglePayload,
  CheckResponse
} from '@/tcw/api/types'
import { KEY_CLASS_SHOUNIN_STATUS } from '@/tcw/constant/KeyClass'
import * as ApiPath from '@/tcw/constant/ApiPath'
import Getsudo from '@/tcw/domain/Getsudo'
import { TcwAPIID } from '@/tcw/domain/types'
import { ERR_CODE_SERVER_VALID, ERR_CODE_WEB_API_NOT_FOUND } from '@/tcw/constant/ErrorCode'
import { IFormStore } from '@/store/types'
import { shouninStore } from '@/store/form/ShouninFormStore'
import { kintaiInputStore } from '@/store/form/KintaiInputFormStore'
import { koutsuhiInputStore } from '@/store/form/KoutsuhiInputFormStore'
import { TCWApiError } from '@/plugins/TCWBaseError'
import { KeyInfo } from '@/components/common/form/types'
import ShouninActionExecInfo from '@/components/shounin/molecules/ShouninActionExecInfo.vue'
import ShouninComment from '@/components/shounin/molecules/ShouninComment.vue'

@Component({
  components: { ShouninActionExecInfo, ShouninComment }
})
export default class ShouninInputForm extends Mixins(FormStoreComponent) {
  @Prop({ default: () => Getsudo.now() })
  protected getsudo!: Getsudo
  @Prop({ default: '' })
  protected userId!: TcwAPIID
  @Prop({ default: '' })
  protected status!: string
  @Prop({ type: Boolean, default: false })
  protected editable!: boolean

  @Emit()
  protected clickBack(): void {
    /** */
  }
  @Emit()
  protected noAction(): void {
    /** */
  }

  protected message = ''
  protected nextTantousha: string | undefined
  protected teishutsu: ApiGeneralSinglePayload = {}
  protected statusName = ''
  protected summary: ApiGeneralSinglePayload = {}
  protected buttonLabel = ''
  protected buttonType = ''
  protected dialogVisible = false
  protected footerHeight = 46
  protected isLoaded = false
  protected selectedAction: ApiGeneralSinglePayload | null = null

  protected hasError = false

  get formName(): string {
    return 'shouninForm'
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return shouninStore
  }
  get keyInfo(): KeyInfo {
    return {
      year: this.getsudo.yearValue,
      month: this.getsudo.monthValue,
      userId: this.userId ? this.userId : '',
      actionCode: this.selectedAction?.code as string
    }
  }
  get isEmptyRecord(): boolean {
    return false
  }

  get form(): ApiGeneralSinglePayload {
    return this.storeModule.editData !== null ? this.storeModule.editData : {}
  }
  get shouninRoute(): string {
    if (this.status === '3') {
      // 完了済みの場合
      return '-'
    } else if (this.isSaishuShouninsha) {
      // 最終承認者の場合
      return `${this.form.shouninUserName} → [完了]`
    } else {
      return `${this.form.shouninUserName} → ${this.nexstShouninUserNames}`
    }
  }
  get teishutsuSha(): string {
    return typeof this.form.teishutsushaName === 'string' ? this.form.teishutsushaName : ''
  }
  get teishutsuGetsudo(): string {
    return `${this.getsudo.yearValue}年${this.getsudo.monthValue}月度`
  }

  get tsugiShouninUserList(): ApiGeneralObjectArrayPayload {
    return Array.isArray(this.form.tsugiShouninUserList)
      ? (this.form.tsugiShouninUserList as ApiGeneralObjectArrayPayload)
      : []
  }
  get nexstShouninUserNames(): string {
    return this.tsugiShouninUserList.map(shounin => shounin.userName).join(',')
  }
  get maeShouninList(): ApiGeneralObjectArrayPayload {
    return Array.isArray(this.form?.maeShouninList)
      ? (this.form.maeShouninList as ApiGeneralObjectArrayPayload)
      : []
  }
  get maeShouninUserNames(): string {
    return this.maeShouninList.map(shounin => shounin.shouninUserName).join(',')
  }

  get isSaishuShouninsha(): boolean {
    // 次承認者がいない
    const notHaveTsugishouninsha = this.tsugiShouninUserList.length === 0
    return notHaveTsugishouninsha
  }

  get actionList(): ApiGeneralObjectArrayPayload {
    return _.isArray(this.form.abailableActionList)
      ? ([...this.form.abailableActionList].reverse() as ApiGeneralObjectArrayPayload)
      : []
  }
  get hasActionList(): boolean {
    return this.actionList.length > 0
  }
  protected get handleApiError(): ApiErrorHandle {
    return {
      [ERR_CODE_WEB_API_NOT_FOUND]: (error: TCWApiError) => {
        // リソースなし
        this.$tcw.message({
          type: 'warning',
          title: error.message,
          message: `${error.getMessageDetail()}`
        })
        this.noAction()
        return Promise.resolve(true)
      },
      [ERR_CODE_SERVER_VALID]: (error: TCWApiError) => {
        // サーバチェックエラー
        this.$tcw.message({
          type: 'error',
          title: error.message,
          message: `${error.getMessageDetail()}`
        })
        this.hasError = true

        // 画面遷移
        if (this.userId === this.loginUserId) {
          // 自ユーザの場合は提出状況確認画面へ
          this.goto(`/kintai/list`)
        }
        return Promise.resolve(true)
      }
    }
  }

  protected async afterProc(): Promise<void> {
    this.statusName = await this.codeLabel.getLabelByCode({
      keyClass: KEY_CLASS_SHOUNIN_STATUS,
      code: this.status
    })
    // 自ユーザの場合は勤怠データのエラー状態をチェック
    if (this.userId === this.loginUserId) {
      const apiPath = ApiPath.buildPath(ApiPath.Paths.KintaiCheck.other, {
        year: this.getsudo.yearValue,
        month: this.getsudo.monthValue,
        userId: this.userId ? this.userId : ''
      })
      const response: CheckResponse = await this.getWebApi().call<CheckResponse>(apiPath, 'GET')
      // チェック結果がエラーの場合、勤怠一覧に戻る
      if (response.resultCode && response.resultCode === 'ERROR') {
        this.$tcw.message({
          type: 'error',
          title: '勤怠データにエラーがあります',
          message: '入力チェックを実施してエラーを修正してください'
        })
        this.$tcw.$store.basic.setKintaiCheckMode(true) // チェックモードをONにする
        // 月度を変更
        this.$tcw.$store.basic.setTargetDate(Getsudo.last(this.shimebi).getDate())
        this.goto(`/kintai/list`)
      }
    }
  }

  protected setButton(actionCode: string | number): void {
    switch (String(actionCode)) {
      case '1':
        this.buttonLabel = '提出'
        this.buttonType = 'primary'
        this.message = '提出します'
        this.nextTantousha = this.nexstShouninUserNames
        break
      case '2':
        this.buttonLabel = '承認'
        this.buttonType = 'success'
        this.message = '承認します'
        this.nextTantousha = this.nexstShouninUserNames
        break
      case '3':
        this.buttonLabel = '完了'
        this.buttonType = 'success'
        this.message = '完了します'
        this.nextTantousha = '[完了]'
        break
      case '4':
        this.buttonLabel = '取下'
        this.buttonType = 'danger'
        this.message = '取下します'
        this.nextTantousha = this.$tcw.session.user?.userName
        break
      case '5':
        this.buttonLabel = '前承認者へ差戻'
        this.buttonType = 'danger'
        this.message = '前承認者へ差し戻します'
        this.nextTantousha = this.maeShouninUserNames
        break
      case '6':
        this.buttonLabel = '取下'
        this.buttonType = 'danger'
        this.message = '取下します'
        this.nextTantousha = this.teishutsuSha
        break
      case '7':
        this.buttonLabel = '前回承認者へ再提出'
        this.buttonType = 'primary'
        this.message = '前回承認者へ再提出します'
        this.nextTantousha = this.maeShouninUserNames
        break
      case '8':
        this.buttonLabel = '最初の承認者へ再提出'
        this.buttonType = 'primary'
        this.message = '最初の承認者へ再提出します'
        this.nextTantousha = this.nexstShouninUserNames
        break
      case '9':
        this.buttonLabel = '提出者へ差戻'
        this.buttonType = 'danger'
        this.message = '提出者へ差し戻します'
        this.nextTantousha = this.teishutsuSha
        break
      default:
        break
    }
  }
  protected async afterSaveProc(): Promise<void> {
    this.$tcw.message({
      type: 'success',
      message: `${this.teishutsuSha}${this.getsudo.yearValue}年${this.getsudo.monthValue}月の勤怠を${this.buttonLabel}しました`
    })

    this.dialogVisible = false

    this.clearForm()

    // 画面遷移
    if (this.userId === this.loginUserId) {
      // 勤怠入力、交通費入力フォームをクリア
      kintaiInputStore.clear()
      koutsuhiInputStore.clear()
      // チェックモードをOFFにする
      this.$tcw.$store.basic.setKintaiCheckMode(false)
      // 自ユーザの場合は提出状況確認画面へ
      this.back()
    } else {
      // 他ユーザの場合は
      this.goto('/shounin/tasks')
    }
  }
  protected selectAction(action: ApiGeneralSinglePayload): void {
    this.selectedAction = action
    this.setButton(action.code as string)
    this.dialogVisible = true
  }
}
